import axiosInstance from "../../../helpers/api";

// Get all live videos
export const getAllLiveVideos = () => {
  return axiosInstance.get("/superadmin/live-videos");
};

// Get live video by ID
export const getLiveVideoById = (id) => {
  return axiosInstance.get(`/superadmin/live-videos/${id}`);
};

// Create live video
export const createLiveVideo = (data) => {
  return axiosInstance.post("/superadmin/live-videos", data);
};

export const updateLiveVideo = (id, data) => {
  return axiosInstance.post(`/superadmin/live-videos/${id}`, data);
};

// Delete live video
export const deleteLiveVideo = (id) => {
  return axiosInstance.delete(`/superadmin/live-videos/${id}`);
};

// Get live videos by course
export const getLiveVideosByCourse = (courseId) => {
  return axiosInstance.get(`/superadmin/live-videos/courses/${courseId}`);
};

// Get live videos by teacher
export const getLiveVideosByTeacher = (teacherId) => {
  return axiosInstance.get(`/superadmin/live-videos/teachers/${teacherId}`);
}; 